import { FabricObject, IText } from 'fabric';
import type { TextAlign } from '../shared/types/text-align';

export interface PillIconMeta {
  src: string;
  side: 'left' | 'right';
  width: number;
  height: number;
  /** Gap between icon and text. */
  gap: number;
}

export interface PillMeta {
  fill: string;
  stroke: string;
  strokeWidth: number;
  borderRadius: number;
  /** Horizontal padding. Per-side overrides via paddingLeft/Right. */
  paddingX: number;
  paddingY: number;
  paddingLeft?: number;
  paddingRight?: number;
  /** Floor on the pill width; textAlign decides how the text sits when wider than the text fit. */
  minWidth: number;
  icon?: PillIconMeta;
}

/** @deprecated Use TextAlign — kept as an alias for the public API. */
export type PillTextAlign = TextAlign;

export interface PillCreateConfig {
  left: number;
  top: number;
  text: string;
  fill: string;
  textFill: string;
  fontFamily: string;
  fontSize: number;
  fontWeight?: number | string;
  fontStyle?: 'normal' | 'italic';
  textAlign?: PillTextAlign;
  borderRadius?: number;
  paddingX?: number;
  paddingY?: number;
  minWidth?: number;
  stroke?: string;
  strokeWidth?: number;
  paddingLeft?: number;
  paddingRight?: number;
  icon?: PillIconMeta;
}

// IText, not Textbox: Textbox's auto-wrap fights the pill's single-line, auto-width model.
export type PillTextbox = IText & { pill: PillMeta };

export function isPillTextbox(obj: FabricObject | null | undefined): obj is PillTextbox {
  return !!obj && obj instanceof IText && !!obj.pill;
}
